import React from "react";
import NextLink from "next/link";
import { colors } from "utils/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import css from 'styled-jsx/css'

import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faUpRightFromSquare";

// Next component Link doesn't can't be styled with <style jsx="true"> styles. See https://github.com/vercel/next.js/issues/49682
// When rendered Link (<a>) tag doesn't contain jsx-[number] and that is why styles do not applied.
// css.resolve function is used instead to generate jsx-[number] and styles.
function getLinkStyles(color, textDecoration, underlineStyle) {
	return css.resolve`
		a {
			color: ${color || "inherit"} !important;
			cursor: pointer;
			text-decoration: ${underlineStyle ? "none" : (textDecoration || "none")} !important;
		}

		a:hover {
			text-decoration: ${underlineStyle ? "none" : (textDecoration || "underline")} !important;
		}
	`
}


export default function DynamicLink({
	text,
	href,
	classes,
	color,
	textDecoration,
	children,
	noMargin,
	underlineStyle,
	onClick = () => { },
}) {
	const margin = noMargin ? "" : "my-1";
	classes = classes || "";
	const { className, styles } = getLinkStyles(color, textDecoration, underlineStyle);
	const linkClasses = `${className} ${margin} ${classes}`;

	//make the app links dynamic to handle dev / stage / prod
	//if !href, just return original non-href
	href = href ? href.replace("https://app.physicianleaders.org", process.env.APP_URL) : href;
	href = href ? href.replace("https://www.physicianleaders.org", "") : href;
	//add https if needed
	if (href?.startsWith("www.")) {
		href = href.replace("www.", "https://www.");
	}
	const isPlatformLink = href && href.startsWith("http") && href.includes(process.env.APP_URL);
	const isEmail = href && href.includes("@");
	const isExternalLink = href && !isEmail && !isPlatformLink && (!href.startsWith("/") || !href.startsWith("#"));
	const isInternalLink = href && !isPlatformLink && !isEmail && (href.startsWith("/") || href.startsWith("#"));
	href = isInternalLink ? href.replace("/news/", "/articles/") : href; //this is to save time updating any /news/ links
	return (
		<span className={classes} onClick={onClick}>
			{!href && (
				<span className={`${margin} d-inline-block ${classes}`}>
					{children && children}
					{text && text}
				</span>
			)}
			{/* EMAIL LINKS */}
			{isEmail && (
				<a
					href={href.includes("mailto:") ? href : `mailto:${href}`}
					target={"_blank"}
					className={`${linkClasses} ${underlineStyle ? 'underline-link' : ''}`}
				>
					{children && children}
					{text && text}
				</a>
			)}
			{/* EXTERNAL HTTP LINK DIFFERENT DOMAIN  */}
			{/* Route to link in a new window */}
			{isExternalLink && !isInternalLink && (
				<a href={href} target={"_blank"} className={`${linkClasses} relative d-inline align-items-center ${underlineStyle ? 'underline-link' : ''}`}>
					{children && children}
					{text && text} <FontAwesomeIcon className="external-link-icon ms-1" icon={faUpRightFromSquare} />
				</a>
			)}

			{/* EXTERNAL LINK SAME DOMAIN */}
			{/* route to link in same window */}
			{isPlatformLink && (
				<a href={href} className={`${linkClasses} ${underlineStyle ? 'underline-link' : ''}`}>
					{children && children}
					{text && text}
				</a>
			)}
			{/* SINGLE-PAGE APP ROUTES */}
			{isInternalLink && (
				<NextLink href={href} className={`${linkClasses} ${underlineStyle ? 'underline-link' : ''}`}>
					{children && children}
					{text && text}
				</NextLink>
			)}
			{styles}
			{underlineStyle && (
				<style jsx="true">{`
					.underline-link {
						position: relative;
						display: inline;
						width: fit-content;
						text-decoration: none !important;
						font-size: 12px !important;
						letter-spacing: 0px !important;
						font-weight: 700 !important;
						border-bottom: 2px solid #D4A574;
						transition: all 0.3s ease;
					}
					
					.underline-link:hover {
						text-decoration: none !important;
						border-bottom-color: #B8945F;
						transform: scaleX(1.1);
					}
				`}</style>
			)}
		</span>
	);
}
